
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showVariantOptionsTile: null
    };
  },
  methods: {
    handleAddPackagingCharge() {
      this.$emit("show-add-packaging-charge-dialog");
    },
    modifyPackagingCharge() {
      this.$emit("modify-packaging-charge");
    },
    deletePackagingCharge() {
      this.$emit("delete-packaging-charge");
    },
    handleAddVariantPricing() {
      this.$emit("show-add-variant-dialog");
    },
    modifyVariant(i) {
      this.$emit("modify-variant", this.item.variants[i]);
      this.showVariantOptionsTile = null;
    },
    deleteVariant(i) {
      this.$emit("delete-variant", this.item.variants[i]);
      this.showVariantOptionsTile = null;
    },
    handleShowPriceModifyDialog() {
      this.$emit("show-price-modify-dialog");
    }
  }
};
